import { Box, Button, Paper, Typography } from "@mui/material"

import { useDispatch } from "react-redux"
import { updateActiveSideBAr } from "../redux/active_bar"
import AdminSidebar from "../components/adminSideBar"
import Header from "../components/header"
import Products from "../components/product"
import InventoryComponent from "../components/inventory"
import Header1 from "../components/header1"


const Inventory = () => {
    const dispatch = useDispatch()
    // console.log("its is product page")

    return <>
       
       <Box sx={{ bgcolor: { sm: "grey.100", xs: "#fff" }, minHeight: "calc(100vh - 120px)" }}>
                <Header1 />
                <Box sx={{ display: "flex", paddingTop: "144px",gap:"24px",mx:"24px" , position:"relative"}}>
                    <AdminSidebar />
                    <InventoryComponent/>

                </Box>
            
           
            

        </Box>

    </>

}
export default Inventory